import styled from "styled-components"
import { CursorCrosshairWhite, CursorCrosshairBlack } from "shared/Styles/Cursors"
export const Wrapper = styled.div`
  position: absolute;
  bottom: 130px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  ${props=> (props.color ? CursorCrosshairWhite : CursorCrosshairBlack)}
  @media screen and (max-width: 576px) {
    bottom: 100px;
  }
`

export const Text = styled.span`
  font-family: "Bebas Kai Regular", Arial, Helvetica, sans-serif;
  font-size: 16px;
  letter-spacing: 5px;
  text-align: center;
  color: ${props => (props.color ? props.color : props.theme.color.black)};
  margin-bottom: 12px;
`
